// @flow

import { type IncomingPayment, getAddress, getPhoneNumber, getDocument, getCountry } from '@tectonics/prs/incoming-payment';
import { getZipcode } from '@tectonics/prs/address';
import { CHILE } from '@tectonics/commons/country/country';
import { getZipcodeNormalizer, getPhoneNumberNormalizer } from '@tectonics/prs/customer/normalize';
import { normalizeCustomerDocument } from './normalize-customer-document';
import { normalizeCustomerDocument as normalizeChileanCustomerDocument } from '@tectonics/prs/customer/chile/normalize';

export function normalizeCustomerIncomingPayment<T: IncomingPayment>(incomingPayment: T): T {
  const address = getAddress(incomingPayment);
  const country = getCountry(incomingPayment);
  const documentNormalizer = country === CHILE.code ? normalizeChileanCustomerDocument : normalizeCustomerDocument;

  return {
    ...incomingPayment,
    zipcode: getZipcodeNormalizer(country)(getZipcode(address)),
    phone_number: getPhoneNumberNormalizer(country)(getPhoneNumber(incomingPayment)),
    document: documentNormalizer(getDocument(incomingPayment)),
  };
}
